import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef, OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';
import {XuLyToTrinhComponent} from './xulytotrinh/xulytotrinh.component';
import {ToTrinhNhanComponent} from './totrinhnhan/totrinhnhan.component';
import {ToTrinhDangSoanComponent} from './totrinhdangsoan/totrinhdangsoan.component';
import {YeuCauGuiComponent} from './yeucaugui/yeucaugui.component';
import {YeuCauNhanComponent} from './yeucaunhan/yeucaunhan.component';
import {YeuCauDangSoanComponent} from './yeucaudangsoan/yeucaudangsoan.component';
import {ThongBaoComponent} from '../thongbao/thongbao.component';
import {GiaiQuyetSuVuTongHopComponent} from './tonghop/tonghop.component';
import {SoanToTrinhComponent} from './soantotrinh/soantotrinh.component';
import {SoanYeuCauComponent} from './soanyeucau/soanyeucau.component';
import {SoanThongBaoComponent} from '../thongbao/create.component';
import {MeetingComponent} from '../meeting/meeting.component';
import {SoanMeetingComponent} from '../meeting/create.component';
import {environment} from '../../../../environments/environment';
import {ToTrinhService} from '../../../service/totrinh/service-totrinh';
import {Sessioncommand} from '../../../global/sessioncommand';
import {ToTrinhXuLyService} from '../../../service/totrinh/service-totrinhxuly';
import {YeuCauService} from '../../../service/yeucau/service-yeucau';
import {YeuCauXuLyService} from '../../../service/yeucau/service-yeucauxuly';
import {MeetingService} from '../../../service/info/service-meeting';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoViewComponent} from '../thongbao/thongbaoview.component';
import {ActivatedRoute} from '@angular/router';
import {NavItemService} from '../../../service/staff/service-navitem';
import {MeetingXuLyService} from '../../../service/info/service-meetingxuly';
import {ThuTempService} from '../../../service/email/service-thutemp';
import {ThuService} from '../../../service/email/service-thu';
import {DocumentDraftService} from '../../../service/draft/service-documentdraft';
import {SoanThuComponent} from '../email/soanthu/soanthu.component';
import {EmailTongHopComponent} from '../email/tonghop/tonghop.component';
import {ThuDaGuiComponent} from '../email/thudagui/thudagui.component';
import {ThuDaNhanComponent} from '../email/thudanhan/thudanhan.component';
import {ThuDaXoaComponent} from '../email/thudaxoa/thudaxoa.component';
import {ThuChuaDocComponent} from '../email/thuchuadoc/thuchuadoc.component';
import {ThuDaDocComponent} from '../email/thudadoc/thudadoc.component';
import {ThuDangSoanComponent} from '../email/thudangsoan/thudangsoan.component';
import {ThungRacComponent} from '../email/thungrac/thungrac.component';
import {ThuGuiDaXoaComponent} from '../email/thuguidaxoa/thuguidaxoa.component';



@Component({
  templateUrl: './giaiquyetsuvu.component.html'

})
export class GiaiQuyetSuVuComponent implements OnInit, AfterViewInit, OnDestroy  {
  @ViewChild('container', { read: ViewContainerRef })
  public viewContainerRef: ViewContainerRef;
  public showRef: ComponentRef<Object>;
  public language = language;
  public totalToTrinhXuLy: number =0;
  public totalToTrinhNhan: number =0;
  public totalToTrinhDangSoan: number =0;
  public totalYeuCauGui: number =0;
  public totalYeuCauNhan: number =0;
  public totalYeuCauDangSoan: number =0;
  public totalCuocHop:  number=0;
  public totalThongBao: number =0;
  public totalThongBaoNhap: number =0;
  public viewGQInternal;
  public permissionToTrinh: boolean = false;
  public permissionYeuCau: boolean = false;
  public permissionThongBao: boolean = false;
  public permissionDocThongBao: boolean = false;
  public permissionThongBaoPrivate: boolean = false;
  public permissionCuocHop: boolean = false;
  public permissionThamGiaCuocHop: boolean = false;
  public  colMain: string = 'col-md-9';
  public  titleCard: string = language.giaiquyetsuvu;
  public status: number[] =[
    environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  public staffsId: number = Sessioncommand.staffId;
  public totalThuGui: number =0;
  public totalThuNhan: number =0;
  public totalThuXoa: number =0;
  public totalThuGuiXoa: number =0;
  public totalThuSoan: number =0;
  public totalThungRacNhan: number = 0;
  public totalThungRacGui: number = 0;
  public viewEmailInternal;
  public nguoiTao: number = Sessioncommand.staffId;
  public emailStatus: string = '1';

  constructor( public componentFactoryResolver: ComponentFactoryResolver,
               public  toTrinhService: ToTrinhService,
               public toTrinhXuLyService: ToTrinhXuLyService,
               public yeuCauService: YeuCauService,
               public yeuCauXuLyService: YeuCauXuLyService,
               public meetingService: MeetingService,
               public thongBaoService: ThongBaoService,
               public route: ActivatedRoute,
               public navItemService: NavItemService,
               public thuTempService: ThuTempService,
               public thuService: ThuService,
               public documentDraftService: DocumentDraftService,
  ) {
  }
  ngAfterViewInit() {
    this.route.queryParams.
    subscribe(params => {
        if(params.ty == null)
          this.showTongHop();
        else {
          if (params.ty == 'tt' || params.ty == 'ttg')
            this.showToTrinhGui();
          if (params.ty == 'ttn')
            this.showToTrinhNhan();
          if (params.ty == 'yc' || params.ty == 'ycg')
            this.showYeuCauGui();
          if (params.ty == 'ycn')
            this.showYeuCauNhan();
          if (params.ty == 'tb')
            this.showThongBao();
          if (params.ty == 'dtb')
            this.showDocThongBao();
          if (params.ty == 'mt')
            this.showMeeting();
          if (params.ty == 'ycs')
            this.showYeuCauDangSoan();
          if (params.ty == 'tts')
            this.showToTrinhDangSoan();
          if(params.ty == 'tdg')
            this.showThuDaGui();
          if(params.ty == 'tdn')
            this.showThuDaNhan();
          if(params.ty == 'tdx')
            this.showThuDaXoa();
          if(params.ty == 'tcd')
            this.showThuChuaDoc();
          if(params.ty == 'tdd')
            this.showThuDaDoc();
          if(params.ty == 'tds')
            this.showThuDangSoan();
          if(params.ty == 'trac')
            this.showThungRac();

        }

      }
    );
    this.loadTotal();
    this.viewGQInternal = setInterval(() => {
      if (Sessioncommand.giaiQuyetSuVuStatus === 0 || Sessioncommand.emailStatus ===0 )
      this.loadTotal();
    }, 2000);
  }
  ngOnDestroy() {
    if ( this.viewGQInternal) {
       clearInterval(this.viewGQInternal);
     }
  }
  public changeColMain()
  {
    if(this.colMain === 'col-md-9')
      this.colMain= 'col-md-12';
    else
      this.colMain= 'col-md-9';
  }
  public showComponent(component)
  {
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const comRef= viewRef.createComponent(factory);
    this.showRef= comRef;
  }
  public  loadTotal()
  {
    Sessioncommand.giaiQuyetSuVuStatus = 1;
    Sessioncommand.emailStatus =1;
    this.toTrinhService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalToTrinhNhan = recordCount);
    this.toTrinhService.getCountByKeyword('', environment.soanthao.toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhDangSoan = recordCount);
    this.yeuCauService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauGui = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauNhan = recordCount);
    this.yeuCauService.getCountByKeyword('',  environment.soanthao.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauDangSoan = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), this.staffsId, -1).subscribe(recordCount => this.totalCuocHop = recordCount);
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
      x => {

        this.thongBaoService.getCountByKeyword('', (x > 0 ? -1 : Sessioncommand.staffId), -1).subscribe(recordCount => this.totalThongBao = recordCount);
        this.thongBaoService.getCountByQLKeyword('', (x > 0 ? -1 : Sessioncommand.staffId)).subscribe(recordCount => {this.totalThongBaoNhap = recordCount; });
      }
    );
    this.thuTempService.getCountByKeyword('', this.nguoiTao, -1, 0 ).subscribe(recordCount => this.totalThuGui = recordCount);
    this.thuTempService.getCountByKeyword('', this.nguoiTao, -1, 1 ).subscribe(recordCount => this.totalThungRacGui = recordCount);
    this.thuService.getCountByKeyword('', this.nguoiTao, -1, 0 , this.emailStatus).subscribe(recordCount => this.totalThuNhan = recordCount);
    this.thuService.getCountByKeyword('', this.nguoiTao, -1, 1 , this.emailStatus).subscribe(recordCount => this.totalThungRacNhan = recordCount);
    this.documentDraftService.getCountByKeyword('','EMAIL', this.nguoiTao ).subscribe(recordCount => this.totalThuSoan = recordCount);
  }
  public showSoanToTrinh() {
    this.titleCard = language.soantotrinh;
    this.showComponent(SoanToTrinhComponent);

  }
  public showSoanMeeting() {
    this.titleCard = language.taomoicuochop;
    this.showComponent(SoanMeetingComponent);

  }
  public showMeeting() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachcuochop;
    this.showComponent(MeetingComponent);

  }
  public showSoanThongBao() {

    this.titleCard = language.taomoithongbao;
    this.showComponent(SoanThongBaoComponent);

  }
  public showDocThongBao() {
    this.colMain = 'col-md-12';
    this.titleCard = language.docthongbao;
    this.showComponent(ThongBaoViewComponent);

  }
  public showTongHop() {
    this.titleCard = language.tonghop;
    this.showComponent(GiaiQuyetSuVuTongHopComponent);

  }
  public showToTrinhGui() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachtotrinh_baocaogui;
    this.showComponent(XuLyToTrinhComponent);

  }
  public showToTrinhNhan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachtotrinh_baocaonhan;
    this.showComponent(ToTrinhNhanComponent);
  }
  public showToTrinhDangSoan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachtotrinh_baocaodangsoan;
    this.showComponent(ToTrinhDangSoanComponent);
  }
  public showYeuCauGui() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachgiaoviec_yeucaugui;
    this.showComponent(YeuCauGuiComponent);

  }
  public showYeuCauNhan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachgiaoviec_yeucaunhan;
    this.showComponent(YeuCauNhanComponent);

  }
  public showYeuCauDangSoan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachgiaoviec_dangsoan;
    this.showComponent(YeuCauDangSoanComponent);
  }
  public showThongBao() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthongbao;
    this.showComponent(ThongBaoComponent);
  }
  public showSoanYeuCau() {
    this.titleCard = language.soangiaoviecmoi;
    this.showComponent(SoanYeuCauComponent);
  }
  public showSoanThu() {

    this.titleCard = language.soanthumoi;
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(SoanThuComponent);
    const component: ComponentRef<SoanThuComponent> = this.viewContainerRef.createComponent(factory);
    component.instance.target = '/giaiquyetsuvu/qlsuvu';
    this.showRef= component;
  }
  public showThuDaGui() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_dagui;
    this.showComponent(ThuDaGuiComponent);
  }
  public showThuDaNhan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_danhan;
    this.showComponent(ThuDaNhanComponent);
  }
  public showThuDaXoa() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_daxoa;
    this.showComponent(ThuDaXoaComponent);
  }
  public showThuChuaDoc() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_chuadoc;
    this.showComponent(ThuChuaDocComponent);
  }
  public showThuDaDoc() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_dadoc;
    this.showComponent(ThuDaDocComponent);

  }
  public showThuDangSoan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_dangsoan;
    this.showComponent(ThuDangSoanComponent);

  }
  public showThungRac() {
    this.colMain = 'col-md-12';
    this.titleCard = language.thungrac;
    this.showComponent(ThungRacComponent);

  }
  public showThuGuiDaXoa() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsach_thuguixoa;
    this.showComponent(ThuGuiDaXoaComponent);

  }
  ngOnInit(): void {
    Sessioncommand.sideBarActive = true;
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0022', true).subscribe(
      x => { this.permissionToTrinh = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0019', true).subscribe(
      x => { this.permissionThongBaoPrivate = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0025,0026', true).subscribe(
      x => { this.permissionYeuCau = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0018', true).subscribe(
      x => { this.permissionThongBao = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0020,0021', true).subscribe(
      x => { this.permissionDocThongBao = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001,0078", true).subscribe(
      x => { this.permissionCuocHop = x> 0? true: false;
        this.staffsId = this.permissionCuocHop === true? -1: this.staffsId;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001,0079", true).subscribe(
      x => { this.permissionThamGiaCuocHop = x> 0? true: false;
        this.staffsId = this.permissionThamGiaCuocHop === true? -1: this.staffsId;
        this.meetingService.getCountByKeyword('', this.status.join().toString(), this.staffsId, -1).subscribe(recordCount => this.totalCuocHop = recordCount);
      }
    );

  }



}

